//This will be the dropdown item you see on the schedule page.  You can choose from
//either a league or a team to view a desired schedule
import React, { useState, useEffect } from 'react'
import './AdminSearchByVenue.css'
import { useNavigate } from 'react-router-dom'

const AdminSearchByTeam = () => {
	const [isLoading, setIsLoading] = useState(false)
	const [loadedTeams, setLoadedTeams] = useState()
	const [error, setError] = useState()

	let selectedTeam
	//
	//
	//
	//Call backend to get all the current teams for our dropdowns
	//     getCurrentTeam
	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + '/admin/teams/current'
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				console.log('responseData: ' + JSON.stringify(responseData))
				setLoadedTeams(responseData.currentTeams)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			//
			setIsLoading(false)
		}
		sendRequest()
	}, [])

	let teamsArray

	if (loadedTeams && !isLoading) {
		teamsArray = []
		loadedTeams.forEach((team) => {
			teamsArray.push(team.teamName)
		})
	}

	let navigate = useNavigate()

	//For handling a search by TEAMS request
	const handleChange = (e) => {
		e.preventDefault()
		const selectedValue = e.target.value
		selectedTeam = loadedTeams[selectedValue]
		const teamId = selectedTeam._id
		navigate(`/admin/${teamId}/teamschedule`) //  < - - - goes to AdminTeamSchedule
	}

	return (
		<React.Fragment>
			<div className='row'>
				<div className='col-sm'></div>
				<div
					className='col-sm instructions searchByVenue'
					style={{ fontSize: 'larger', padding: '0.75rem' }}
				>
					Filter by Team:{' '}
				</div>
				{!isLoading && loadedTeams && (
					<div className='col-sm'>
						<form className='form-control-lg' style={{ marginBottom: '2rem' }}>
							{/* matt:  wtf is custom-select?   was a className here but i deleted*/}
							<select
								className='my-1 mr-sm-2 scheduleselector'
								onChange={handleChange}
							>
								<option defaultValue>Select Team....</option>
								{teamsArray.map((team, i) => (
									<option value={i} key={i}>
										{team}
									</option>
								))}
							</select>
						</form>
					</div>
				)}
				<div className='col-sm'></div>
			</div>
			{/* </div> */}
		</React.Fragment>
	)
}

export default AdminSearchByTeam
